<template>
  <div class="col-12 bg-white rounded mt-n3">
    <validation-observer
      ref="returnToPreviousStatusForm"
      v-slot="{}"
      tag="form"
    >
      <div class="row mb-n3">
        <div class="col-12 mt-2">
          <p>
            <i class="h6 fas fa-undo text-orange mr-2 font-weight-bold" />
            <span class="font-weight-bold color-gray-7">
              Regresar Estatus Anterior
            </span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <validation-provider
            v-slot="{ errors }"
            name="cancelComment"
            rules="required"
          >
            <label class="data-title mb-0">Comentario:</label>
            <custom-text-area
              v-model="model.comment"
              :count-classes="['float-right']"
              custom-error-msg="El comentario es requerido."
              :error="errors[0]"
              :maxlength="3000"
              show-char-count
            />
          </validation-provider>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3 mr-3">
          <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
            <div class="bd-highlight ml-2">
              <action-button
                i="fas fa-save fa-lg"
                text="Guardar"
                variant="success"
                @click="submitForm()"
              />
            </div>
            <div class="mx-0 bd-highlight">
              <action-button
                id="modal-btn-cancelar"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="$emit('cancel')"
              />
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';

import {
  returnToPreviousStatus as _returnToPreviousStatus,
  getPreviousStatus as _getPreviousStatus,
} from '@/services/provider/extended-academic-year.api';

export default {
  name: 'AEEReturnPreviousStatus',
  components: {
    ValidationProvider,
    CustomTextArea,
    ActionButton,
  },
  mixins: [alert],
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        comment: null,
      },
    };
  },
  methods: {
    async submitForm() {
      const isFormValid = await this.$refs.returnToPreviousStatusForm.validate();
      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      await this.submitToPreviousStatus();
    },
    async submitToPreviousStatus() {
      const { data: status } = await _getPreviousStatus(
        this.data.requestId
      ).catch((error) => {
        let message = error.response.data.message ?? error.message;
        this.ShowToast('Alerta', `${message}.`, 'error');
        return { data: false };
      });

      if (status) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro(a) que desea regresar al estatus anterior [${status}]?`,
          'Sí',
          'No'
        );
        if (!answer) return;

        const payload = {
          requestServiceId: this.data.requestId,
          ...this.model,
        };

        const { data } = await _returnToPreviousStatus(payload).catch(
          (error) => {
            this.ShowToast('Alerta', `${error.message}.`, 'error');
            return { data: false };
          }
        );

        if (data)
          this.ShowToast(
            `Confirmación`,
            'El estatus ha sido actualizado exitosamente.',
            'success'
          );

        this.$emit('on-save', data);
      }
    },
  },
};
</script>
